export const STORAGE_KEYS = {
  USER_ADDRESS: 'user_address',
}
